import { createAsyncThunk } from '@reduxjs/toolkit';
import areaScopeApi from '~/apis/areaScope';
import { CREATE_AREA_SCOPE, EDIT_AREA_SCOPE, GET_AREA_SCOPE, GET_AREA_SCOPES } from '~/utils/constants/actionType';
import { IAreaScope, IEditAreaScope, IParamsGetAreaScope, IResponseGetAreaScope } from '~/utils/interface/areaScope';

export const handleCreateAreaScope = createAsyncThunk<IAreaScope, IEditAreaScope>(
  CREATE_AREA_SCOPE,
  async (data: IEditAreaScope, { rejectWithValue }) => {
    try {
      const res = await areaScopeApi.create(data);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
export const handleGetAreaScopeList = createAsyncThunk<IResponseGetAreaScope, IParamsGetAreaScope>(
  GET_AREA_SCOPES,
  async (params: IParamsGetAreaScope, { rejectWithValue }) => {
    try {
      const res = await areaScopeApi.getList(params);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const handleGetAreaScope = createAsyncThunk<IAreaScope, string>(
  GET_AREA_SCOPE,
  async (id: string, { rejectWithValue }) => {
    try {
      const res = await areaScopeApi.getDetail(id);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
export const handleEditAreaScope = createAsyncThunk<IAreaScope, { id: string; params: IEditAreaScope }>(
  EDIT_AREA_SCOPE,
  async ({ id, params }, { rejectWithValue }) => {
    try {
      const res = await areaScopeApi.update(id, params);
      return res.data.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
